import { render, staticRenderFns } from "./Jackpots.vue?vue&type=template&id=dd38ce7c&scoped=true"
import script from "./Jackpots.vue?vue&type=script&lang=js"
export * from "./Jackpots.vue?vue&type=script&lang=js"
import style0 from "./Jackpots.vue?vue&type=style&index=0&id=dd38ce7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd38ce7c",
  null
  
)

export default component.exports